var render = function render(_c,_vm){return _c('svg',{attrs:{"id":_vm.props.id,"width":_vm.props.width || 12,"height":_vm.props.height || 6,"viewBox":"0 0 12 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 6L0.803847 -2.51245e-08L11.1962 8.834e-07L6 6Z","fill":_vm.props.fill || '#BABABA'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }